import { get, post, put, patch } from "../Config"

export function SearchPdpa({ params = {}, lang }) {
  return get({ url: `/v1/admin/usage-policy`, params, lang })
}
export function GetPdpaById({ id, params = {}, lang, }) {
  return get({ url: `/v1/admin/usage-policy/${id}`, params , lang })
}
export function CreatePdpa({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/usage-policy`, params, data, lang })
}
export function UpdatePdpa({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/usage-policy/${id}`, params, data, lang })
}
export function PatchPdpa({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/usage-policy/${id}`, params, data, lang })
}
export function DeletePdpa({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/usage-policy/mutiDelete`, params, data, lang })
}
